import $ from 'jquery';
import ga from 'ga';
import screenSize from 'core/screenSize';
import 'modules/mentions_legales';
import 'sass/cadremploi-webapp/modules/_toaster-creation-alerte.scss';
import 'jquery.cookie';

const TOASTER_DETAIL_COOKIE_NAME = 'CeToasterAlerteDetailOffreAlreadyClosed';
const TOASTER_LISTE_COOKIE_NAME = 'CeToasterAlerteListeOffreAlreadyClosed';

class ToasterCreationAlerte {
  constructor(configuration, offreId) {
    this.isFromDetail = offreId !== undefined;
    this.alerteExistante = configuration.isAlerteExistante;
    this.isOpen = false;

    const $formCreationAlerte = $('.js-toaster-creation-alerte-form');
    $('.js-rappel-criteres-alerte').html(configuration.criteres);

    $formCreationAlerte.unbind('submit');
    $formCreationAlerte.submit(e => {
      e.preventDefault();
      let email = $('.js-toaster-creation-alerte-email').val();
      let timeout = null;

      ga.sendEvent('navigation', 'clic_toaster_creation_alerte', 'clic_toaster_creation_alerte');

      if (email !== '') {
        $('#js-toaster-creation-alerte-submit-btn').prop('disabled', true);
        const data = this.isFromDetail
          ? JSON.stringify({ email: email, offreId: offreId, provenance: 'toaster_detail' })
          : JSON.stringify({ email: email, provenance: 'toaster_liste' });

        $.ajax({
          type: 'POST',
          url: '/emploi/alerte_email/creer/ajax',
          contentType: 'application/json',
          dataType: 'json',
          data: data,
          success: function(response) {
            this.alerteExistante = true;
            ga.deprecatedSendEvent(
              'creation_alerte',
              'creation_alerte',
              this.isFromDetail ? 'via_toaster_detail' : 'via_toaster_liste'
            );
            $('.js-toaster-validation-alerte').addClass('visible-toaster');
            $('.js-toaster-validation-alerte-lien-gestion-alertes').attr('href', '/emploi/perso/accueil_alertes');
            $('.js-toaster-creation-alerte').removeClass('visible-toaster');
            $('.js-open-toaster-creation-alerte').removeClass('visible-toaster');
            $('#js-toaster-creation-alerte-submit-btn').prop('disabled', false);

            let $checkboxCreerAlerte = $('.js-checkbox-creer-alerte');
            if ($checkboxCreerAlerte) $checkboxCreerAlerte.prop('checked', false);

            if (response.isAvecCreationCompte) {
              ga.deprecatedSendEvent(
                'creation_compte',
                'creation_compte',
                this.isFromDetail
                  ? 'via_creation_alerte_toaster_detail'
                  : 'via_creation_alerte_toaster_liste'
              );

              window.clearTimeout(timeout);
              timeout = window.setTimeout(function() {
                window.location.reload();
              }, 2000);
            }
            this.onAlerteCreationSuccess();
          }.bind(this),
          error: function(error) {
            $('#js-toaster-creation-alerte-submit-btn').prop('disabled', false);
            $('.js-toaster-creation-alerte-form').before(
              '<p id="message" class="alert-box new-warning"><span class="icon-warning"></span> ' +
                $.parseJSON(error.responseText).errors[0] +
                '</p>'
            );
          }
        });
      }
    });

    // Initialisation du toaster
    this.resetState();
    if (
      configuration.ouvrirToaster &&
      !screenSize.isXsScreen() &&
      !$.cookie(this.getCookieName())
    ) {
      if (this.isFromDetail) {
        ga.sendNonInteractiveEvent(
          'navigation',
          'affichage_toaster_creation_alerte',
          'affichage_toaster_creation_alerte'
        );
      } else {
        ga.sendNonInteractiveEvent(
          'temporaire',
          'affichage_liste_toaster_alerte',
          'affichage_liste_toaster_alerte'
        );
      }
      $('.js-toaster-creation-alerte').addClass('visible-toaster');
    } else if (this.alerteExistante) {
      $('.js-open-toaster-creation-alerte.activated').addClass('visible-toaster');
      if (this.isFromDetail) {
        this.renderBtnCreationAlerteBandeauCandidatureRapideGreen();
      } else {
        this.renderBtnCreationAlerteMailExistante();
      }
    } else {
      $('.js-open-toaster-creation-alerte.inactive').addClass('visible-toaster');
      if (!this.isFromDetail) {
        this.renderBtnCreationAlerteMailNonExistante();
      }
    }

    $('.js-open-toaster-creation-alerte').click(() => this.openToaster());

    $('.js-close-toaster-creation-alerte').click(() => {
      $.cookie(this.getCookieName(), 'true', { expires: 7 });
      this.closeToaster();
    });
  }

  renderBtnCreationAlerteMailExistante() {
    $('.js-btn-creer-alerte').addClass('hidden');
    $('.js-alerte-activee')
      .removeClass('hidden')
      .click(() => this.openToaster());
  }

  renderBtnCreationAlerteMailNonExistante() {
    $('.js-btn-creer-alerte')
      .removeClass('hidden')
      .click(() => this.openToaster());
    $('.js-alerte-activee').addClass('hidden');
  }

  renderBtnCreationAlerteBandeauCandidatureRapideGreen() {
    $('#head-scroll-cta .js-open-toaster-creation-alerte > .icon')
      .removeClass('red')
      .addClass('green');
  }

  onAlerteCreationSuccess() {
    if (this.isFromDetail) {
      this.renderBtnCreationAlerteBandeauCandidatureRapideGreen();
    } else {
      this.renderBtnCreationAlerteMailExistante();
    }
  }

  getCookieName() {
    return this.isFromDetail ? TOASTER_DETAIL_COOKIE_NAME : TOASTER_LISTE_COOKIE_NAME;
  }

  get isAlerteExistante() {
    return this.alerteExistante;
  }

  triggerAlerteExistante(isAlerteExistante) {
    this.alerteExistante = isAlerteExistante;
    this.closeToaster();
  }

  resetState() {
    $('.visible-toaster').removeClass('visible-toaster');
    $('.js-open-toaster-creation-alerte').unbind('click');
    $('.js-close-toaster-creation-alerte').unbind('click');
  }

  closeToaster() {
    this.isOpen = false;
    if (this.alerteExistante) {
      $('.js-open-toaster-creation-alerte.activated').addClass('visible-toaster');
    } else {
      $('.js-open-toaster-creation-alerte.inactive').addClass('visible-toaster');
    }

    $('.toaster-creation-alerte-container').removeClass('open-toaster');
    $('.js-toaster-creation-alerte').removeClass('visible-toaster');
    $('.js-toaster-validation-alerte').removeClass('visible-toaster');
    $('.js-toaster-validation-alerte-lien-gestion-alertes').attr('href', '#');
  }

  openToaster() {
    this.isOpen = true;
    if (this.isFromDetail) {
      ga.sendNonInteractiveEvent(
        'navigation',
        'affichage_toaster_creation_alerte',
        'affichage_toaster_creation_alerte'
      );
    } else {
      ga.sendNonInteractiveEvent(
        'temporaire',
        'affichage_liste_toaster_alerte',
        'affichage_liste_toaster_alerte'
      );
    }
    $('.toaster-creation-alerte-container').addClass('open-toaster');
    $('.js-open-toaster-creation-alerte').removeClass('visible-toaster');
    if (!this.alerteExistante) {
      $('.js-toaster-validation-alerte').removeClass('visible-toaster');
      $('.js-toaster-validation-alerte-lien-gestion-alertes').attr('href', '#');
      $('.js-toaster-creation-alerte').addClass('visible-toaster');
    } else {
      $('.js-toaster-creation-alerte').removeClass('visible-toaster');
      $('.js-toaster-validation-alerte').addClass('visible-toaster');
      $('.js-toaster-validation-alerte-lien-gestion-alertes').attr('href', '/emploi/perso/accueil_alertes');
    }
  }
}

export default ToasterCreationAlerte;
